module.exports = __webpack_public_path__ + "static/media/LATTZOTH Image 4.177696bc.png";